<template>
  <FormElement
    :horizontal="true"
    :style="{ 'max-width': '700px', margin: '0 auto' }"
  >
    <fieldset class="k-form-fieldset">
      <div
        v-if="
          kendoForm.visited &&
          kendoForm.errors &&
          kendoForm.errors.VALIDATION_SUMMARY
        "
        class="k-messagebox k-messagebox-error"
      >
        {{ kendoForm.errors.VALIDATION_SUMMARY }}
      </div>
      <Field
        :name="'name'"
        :type="'text'"
        :component="'userForm'"
        :label="nameMessage"
        :validator="nameValidator"
      >
        <template v-slot:userForm="{ props }">
          <FormInput
            :valid="!invalidOptions.includes('name')"
            v-bind="props"
            @change="props.onChange"
            @blur="props.onBlur"
            @focus="props.onFocus"
          />
        </template>
      </Field>
      <Field
        :name="'email'"
        :type="'email'"
        :component="'userForm'"
        :label="emailMessage"
        :validator="emailValidator"
      >
        <template v-slot:userForm="{ props }">
          <FormInput
            :valid="!invalidOptions.includes('email')"
            v-bind="props"
            @change="props.onChange"
            @blur="props.onBlur"
            @focus="props.onFocus"
          />
        </template>
      </Field>

      <Field
        :name="'password'"
        :type="'password'"
        :component="'userForm'"
        :label="textPassword"
        :validator="validatePassword"
      >
        <template v-slot:userForm="{ props }">
          <FormInput
            :valid="!invalidOptions.includes('password')"
            v-bind="props"
            @change="(event) => handleChangePass(props, event.target.value)"
            @blur="props.onBlur"
            @focus="props.onFocus"
          />
        </template>
      </Field>

      <Field
        :name="'password_confirmation'"
        :type="'password'"
        :component="'userForm'"
        :label="textPasswordRepeat"
        :validator="validatePassword"
      >
        <template v-slot:userForm="{ props }">
          <FormInput
            :valid="!invalidOptions.includes('password_confirmation')"
            v-bind="props"
            @change="(event) => handleChangePass(props, event.target.value)"
            @blur="props.onBlur"
            @focus="props.onFocus"
          />
        </template>
      </Field>

      <Field :name="'role_id'" :component="'userForm'" :label="'Роль'">
        <template v-slot:userForm="{ props }">
          <div
            class="form-group-grid form-group-role form-group-select"
            :class="invalidOptions.includes('role_id') ? 'invalid' : ''"
          >
            <label class="form-group-grid__label">Роль</label>
            <select
              class="app-select"
              v-model="props.value"
              @change="props.onChange"
            >
              <option v-for="role in listRoles" :key="role.id" :value="role.id">
                {{ role.name }}
              </option>
            </select>
          </div>
        </template>
      </Field>
    </fieldset>
  </FormElement>
</template>
<script>
import { Field, FormElement } from "@progress/kendo-vue-form";
import FormInput from "../ProfileComponents/FormInput.vue";
import { provideLocalizationService } from "@progress/kendo-vue-intl";
import { ListRoles } from "@/constants/User";
import { getMessageByLang } from '@/utils/translate.js';

import { emailValidator, firstNameValidator } from "../../assets/validators";
export default {
  components: {
    Field,
    FormElement,
    FormInput,
  },
  inject: {
    kendoForm: { default: {} },
    kendoLocalizationService: { default: null },
  },
  props: {
    isEdit: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      nameValidator: firstNameValidator,
      emailValidator: emailValidator,
      listRoles: ListRoles,
      invalidOptions: [],
      password: null,
      passwordConfirmation: null,
      getMessageByLang: getMessageByLang,
    };
  },
  computed: {
    textPassword() {
      return provideLocalizationService(this).toLanguageString(
        "password",
        "password"
      );
    },
    textPasswordRepeat() {
      return provideLocalizationService(this).toLanguageString(
        "passwordRepeat",
        "passwordRepeat"
      );
    },
    nameMessage() {
      return provideLocalizationService(this).toLanguageString("name", "Name");
    },
    emailMessage() {
      return provideLocalizationService(this).toLanguageString(
        "email",
        "Email"
      );
    },
    cancelMessage() {
      return provideLocalizationService(this).toLanguageString(
        "cancel",
        "Cancel"
      );
    },
    loginMessage() {
      return provideLocalizationService(this).toLanguageString(
        "login",
        "Login"
      );
    },
  },
  methods: {
    handleChangePass(prop, value) {
      if (prop.name === "password_confirmation") {
        this.passwordConfirmation = value;
      } else {
        this.password = value;
      }
    },

    validatePassword(value) {
      if (!value) {
        return !this.isEdit ? this.getMessageByLang('requiredOption', 'Обязательное поле') : '';
      }

      if (value.toString().length < 8) {
        return this.getMessageByLang('passwordMoreCharacters', 'Пароль должен быть не менее 8 символов')
      }

      if (this.password !== this.passwordConfirmation) {
        return this.getMessageByLang('passwordIsNotEqual', 'Пароли не совпадают')
      }

      return "";
    },

    clear() {
      this.kendoForm.onFormReset();
    },
    showInvalidOptions(list) {
      this.invalidOptions = list;
    },
  },
};
</script>
<style scoped>
.k-form-buttons {
  justify-content: center;
}

.form-group-role {
  margin-top: 1rem;
}
</style>